import cx from "classnames";

/**
 * A rounded, bordered, lightly tinted card while expanded, so the expanded
 * content visibly ends before the next row starts; collapsed it keeps a
 * transparent border so toggling does not shift the row.
 */
export const getExpandableFrameClassName = (expanded: boolean) =>
  cx("rounded-lg border px-2 transition-colors", {
    "border-neutral-light dark:border-neutral-dark bg-neutral-lightest/50 dark:bg-neutral-dark/50":
      expanded,
    "border-transparent": !expanded,
  });
